import { render, staticRenderFns } from "./Flowchart.vue?vue&type=template&id=3a2523f2&scoped=true"
import script from "./Flowchart.vue?vue&type=script&lang=js"
export * from "./Flowchart.vue?vue&type=script&lang=js"
import style0 from "./Flowchart.vue?vue&type=style&index=0&id=3a2523f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_lodash@4.17.21_prettier@3.5.3_react@19.0.0_vue-template-c_l4y5rdbexcxjh5nqfbzyfvj2aq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2523f2",
  null
  
)

export default component.exports